module.exports = __webpack_public_path__ + "8c3514465079d86f51973513338aa198.png";